import React from 'react';
import './../Styles/Header.scss'

import ChrystarinLogo from './../Images/Logo/logo.png'

interface HeaderProps {
// define your props here
}
  
const Header: React.FC<HeaderProps> = (props) => {
    return (
        <div className="header__container">
            <div className="header">
                <div className='logo__holder'>
                    <a href="/" className="logo" ><img src={ChrystarinLogo} alt="chrystarin_logo"/></a>
                </div>
                <div className="links__holder">
                    {/* <a className="active" href="#home">Home</a> */}
                    <a href="#about">ABOUT</a>
                    {/* <a href="#portfolio">PROJECTS</a> */}
                    {/* <a href="#gallery">Gallery</a>
                    <a href="#contact">Contact</a> */}
                </div>
            </div>
        </div>
       
    );
};

export default Header;